import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

onMounted(() => {
  document.title = "About DERP | ASN.1 Editor and RPKI Test Suite";
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      width: "80vw",
      position: "relative",
      style: {"margin":"20px auto"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("h1", { style: {"text-align":"center"} }, "About DER Parser", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("p", { style: {"text-align":"justify","font-size":"1.5rem"} }, [
              _createTextVNode(" DERP is a web tool suite for parsing, editing and viewing arbitrary ASN.1 encoded files. It allows users to parse DER/base64 encoded objects, edit objects content and structure, and nest the final objects into a functional RPKI repository for testing."),
              _createElementVNode("br"),
              _createTextVNode(" Additionally, it includes integration into the RPKI repository software CURE to live-test edited objects against all real-world RPKI implementations to probe for errors and vulnerabilities. It can thus be used to ensure new configurations are correctly processed by all RPKI software, and to manually create test-cases for RP implementations to identify issues and vulnerabilities. ")
            ], -1),
            _createElementVNode("br", null, null, -1),
            _createElementVNode("h2", { style: {"font-size":"1.5rem","font-weight":"500"} }, " Development and License ", -1),
            _createElementVNode("p", { style: {"font-size":"1.5rem"} }, [
              _createTextVNode(" DERP is developed and maintained by the Cyberbruecke research group at "),
              _createElementVNode("a", { href: "" }, "Goethe University Frankfurt (ATHENE)."),
              _createElementVNode("br"),
              _createTextVNode("Code is available on "),
              _createElementVNode("a", { href: "https://github.com/Cyberbruecke/cure_web" }, "Github"),
              _createTextVNode(" under the MIT license. ")
            ], -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})